module.exports = __webpack_public_path__ + "static/intelectBunk-530e15372456cd38d9716d69e40e9b85.png";